var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.href == null || _vm.href==={})?_c('a',[_vm._t("default")],2):_c('router-link',{attrs:{"to":_vm.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }